import { render, staticRenderFns } from "./Gyms.vue?vue&type=template&id=618aed55&"
import script from "./Gyms.vue?vue&type=script&lang=js&"
export * from "./Gyms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports